var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"company-settings z-index-3 main-container"},[_c('Sidebar'),_c('div',{staticClass:"content"},[_c('Form',{attrs:{"elements":_vm.settingsInputs,"submitAction":_vm.submit,"submitLabel":_vm.$t('save')}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }